const COMPONENT_PREFIX = "savings-banner";

export const SAVINGS_BANNER_TEST_IDS = {
    CONTAINER: `${COMPONENT_PREFIX}-container`,
    TEXT: `${COMPONENT_PREFIX}-text`,
    SUBTEXT: `${COMPONENT_PREFIX}-subtext`,
    IMG: `${COMPONENT_PREFIX}-img`,
};

export const CART_HEADER_DATA_TEST_IDS = {
    BLCK_SAVING_STRIP: "cart-header-blck-saving-strip",
    BOLT_SAVING_STRIP: "cart-header-bolt-saving-strip",
    EO_SAVING_STRIP: "cart-header-eo-saving-strip",
    _99STORE_SAVING_STRIP: "cart-header-99store-saving-strip",
};
